import { getUniversalToken } from '@gp/base'

import { apiClient } from './client'

export const addAppRequestInterceptor = () => {
  apiClient.instance.interceptors.request.use(async (config) => {
    const token = await getUniversalToken()

    config.headers.Authorization = `Bearer ${token.token}`

    return config
  })
}
